import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params }   from '@angular/router';
import { Location }                 from '@angular/common';

import * as _ from 'lodash';

import 'rxjs/add/operator/switchMap';

import { PlanService } from '../../services/plans/plan.service';
import { Auth } from '../../services/auth.service';

@Component({
  moduleId: module.id,
  selector: 'my-plan-detail',
  templateUrl: 'plan-detail.component.html',
  styleUrls: [ '../../users/detail/user-detail.component.css' ]
})

export class PlanDetailComponent implements OnInit {

  plan: any;
  updatedPlan: any;
  _: any;
  loading:boolean=true
  changesAlert:boolean=false;
  saveAlert:boolean=false;
  noChangesAlert:boolean=false;
  hasSysOpsPermission:boolean=false;

  priorityOptions: number[] = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

  closeSaveAlert(){
    this.saveAlert=false;
  }
  closeChangeAlert(){
    this.changesAlert=false;
  }
  closeNoChangeAlert(){
    this.noChangesAlert=false;
  }

  constructor(
    protected planService: PlanService,
    protected route: ActivatedRoute,
    protected location: Location,
    protected auth: Auth
  ) {}

  ngOnInit(): void {

    this.hasSysOpsPermission = this.auth.hasSysOpsPermission();

    this._ = _;

    this.route.params
      .switchMap((params: Params) => this.planService.getOne(params['id'])
      //.then(() => this.loading=false)
      )
      .subscribe((plan) => {

        this.plan = plan;
        this.updatedPlan = _.clone(plan);
        this.loading=false
      });
  }

  goBack(bool:boolean): void {
    let updatedFields: any = this.getUpdatedFields();
    if (!_.isEmpty(updatedFields) && bool != true) {
      this.changesAlert=true;
    }
    else this.confirmGoBack()

  }

  confirmGoBack(){
    this.location.back();
  }

  save(): void {
    let updatedFields: any = this.getUpdatedFields();

    if (_.isEmpty(updatedFields)) {
      this.noChangesAlert = true;
      return;
    }
    this.saveAlert=true;
  }
  saving():void{

    let updatedFields: any = this.getUpdatedFields();
    this.planService.update(this.plan.id, updatedFields)
      .then(() =>
      this.goBack(true));
  }


  private getUpdatedFields(): any {

    let updatedFields = {};
    let self = this;

    _.each(self.updatedPlan, function (value: any, key: string) {

      if (self.plan[key] !== value) {

        updatedFields[key] = value;
      }
    });

    return updatedFields;
  }
}



// WEBPACK FOOTER //
// ./src/app/plans/detail/plan-detail.component.ts